import { Params } from '@angular/router';

export interface UserFilterQueryParams extends Record<
  string,
  string | undefined
> {
  status?: string;
  role?: string;
  search?: string;
}

export class UserFilterMapper {
  static toQueryParams(filters: {
    statusFilter: boolean | null;
    roleFilter: string | null;
    searchTerm?: string;
  }): UserFilterQueryParams {
    const params: UserFilterQueryParams = {};

    if (filters.statusFilter !== null && filters.statusFilter !== undefined) {
      params.status = String(filters.statusFilter);
    }

    const trimmedRole = filters.roleFilter?.trim();
    if (trimmedRole) {
      params.role = trimmedRole;
    }

    const trimmedSearch = filters.searchTerm?.trim();
    if (trimmedSearch) {
      params.search = trimmedSearch;
    }

    return params;
  }

  static fromQueryParams(queryParams: Params): {
    statusFilter: boolean | null;
    roleFilter: string | null;
    searchTerm: string;
  } {
    return {
      statusFilter: queryParams['status']
        ? queryParams['status'] === 'true'
        : null,
      roleFilter: queryParams['role'] ?? null,
      searchTerm: queryParams['search'] ?? '',
    };
  }
}
